{
  "name": "critter-client",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "publish": "ng build --configuration production",
    "publishTst": "ng build --configuration test",
    "publishSbx": "ng build --configuration sandbox",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/common": "^20.3.27",
    "@angular/compiler": "^20.3.27",
    "@angular/core": "^20.3.27",
    "@angular/forms": "^20.3.27",
    "@angular/localize": "^20.3.27",
    "@angular/platform-browser": "^20.3.27",
    "@angular/platform-browser-dynamic": "^20.3.27",
    "@angular/router": "^20.3.27",
    "@grafana/faro-web-sdk": "^2.12.0",
    "@grafana/faro-web-tracing": "^2.12.0",
    "@microsoft/signalr": "^8.0.7",
    "@ng-bootstrap/ng-bootstrap": "^19.0.1",
    "@popperjs/core": "2.11.8",
    "angular-to-phaser": "file:../AngularToPhaser",
    "bootstrap": "5.3.3",
    "crittergames": "file:../CritterGames",
    "prettier": "^3.2.4",
    "rxjs": "~7.8.0",
    "tslib": "^2.6.3",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^19.1.0",
    "@angular-eslint/eslint-plugin": "^19.1.0",
    "@angular-eslint/eslint-plugin-template": "^19.1.0",
    "@angular-eslint/schematics": "^19.1.0",
    "@angular-eslint/template-parser": "^19.1.0",
    "@angular/build": "^20.3.32",
    "@angular/cli": "^20.3.32",
    "@angular/compiler-cli": "^20.3.27",
    "@types/node": "^22.10.0",
    "@typescript-eslint/eslint-plugin": "^7.16.1",
    "@typescript-eslint/parser": "^7.16.1",
    "eslint": "^8.56.0",
    "eslint-plugin-import": "latest",
    "eslint-plugin-jsdoc": "latest",
    "eslint-plugin-prefer-arrow": "latest",
    "typescript": "~5.9.3"
  }
}